module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-02-m.3603f2c543bbc81d87c5c8966631a9e4.png";